import { A } from "@solidjs/router";
import { createResource, Show } from "solid-js";

import { fetchHeatmap, fetchStats } from "../api";
import FrameworkPanel from "../components/FrameworkPanel";
import Heatmap from "../components/Heatmap";
import StatsStrip from "../components/Stats";

export default function Dashboard() {
  const [statsRes] = createResource(fetchStats);
  const [heatmapRes] = createResource(fetchHeatmap);

  return (
    <>
      <FrameworkPanel />

      <Show when={statsRes()} fallback={<div class="loading">loading stats...</div>}>
        {(s) => <StatsStrip stats={s()} />}
      </Show>

      <section class="hm-section">
        <div class="hm-head">
          <h3>FY2025 revenue × operating margin · GICS sectors</h3>
          <div class="hm-right">
            <div class="hm-legend">
              <span class="hm-legend-label">op margin</span>
              <span class="hm-legend-bar" />
              <span class="hm-legend-ticks">
                <span>-30%</span>
                <span>0</span>
                <span>+30%</span>
              </span>
            </div>
            <A href="/sectors" class="dash-link">sector list →</A>
          </div>
        </div>
        <Show
          when={!heatmapRes.loading && (heatmapRes() ?? []).length > 0}
          fallback={<div class="loading">loading heatmap...</div>}
        >
          <Heatmap data={heatmapRes() ?? []} />
        </Show>
      </section>
    </>
  );
}
